import Vue from 'vue';
import fb from '@/firebaseConfig';
import Router from 'vue-router';
import Landing from './views/Landing-View.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: '/',
    },
    {
      path: '/',
      name: 'Landing',
      component: Landing,
      // component: () =>
      //   import(
      //     /* webpackChunkName: "landing" */ /* webpackPrefetch: true */ './views/Landing-View.vue'
      //   ),
      meta: {
        isStoreView: true,
      },
    },
    {
      path: '/app/install',
      name: 'Install',
      component: () =>
        import(
          /* webpackChunkName: "install" */ /* webpackPrefetch: true */ './views/Install-View.vue'
        ),
      meta: {
        isStoreView: true,
        layout: 'store',
      },
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: () => import(/* webpackChunkName: "privacy" */ './views/Privacy-View.vue'),
      meta: {
        isStoreView: true,
        layout: 'store',
      },
    },
    {
      path: '/terms-of-service',
      name: 'TermsOfService',
      component: () => import(/* webpackChunkName: "tos" */ './views/ToS-View.vue'),
      meta: {
        isStoreView: true,
        layout: 'store',
      },
    },
    {
      path: '/app',
      // name: 'App',
      component: () => import(/* webpackChunkName: "app-container" */ './views/App-View.vue'),
      meta: {
        // requiresAuth: true,
        layout: 'app',
      },
      children: [
        {
          path: '/app/auth',
          name: 'Auth',
          component: () => import(/* webpackChunkName: "auth" */ './views/Auth-View.vue'),
          meta: {
            layout: 'app',
          },
        },
        {
          path: '',
          name: 'AppHome',
          component: () => import(/* webpackChunkName: "app-home" */ './views/AppHome-View.vue'),
          meta: {
            requiresAuth: true,
            layout: 'app',
            hasBottomBar: true,
          },
        },
        {
          path: 'category/:category',
          name: 'Category',
          component: () =>
            import(/* webpackChunkName: "app-category" */ './views/Category-View.vue'),
          meta: {
            requiresAuth: true,
            layout: 'app',
            hasTopBar: true,
          },
        },
        {
          path: 'card/:id',
          name: 'Card',
          component: () => import(/* webpackChunkName: "app-card" */ './views/Content-View.vue'),
          meta: {
            requiresAuth: true,
            isContentView: true,
            layout: 'app',
            hasTopBar: true,
          },
        },

        {
          path: 'stacks',
          name: 'Stacks',
          component: () => import(/* webpackChunkName: "app-stacks" */ './views/Stacks-View.vue'),
          meta: {
            requiresAuth: true,
            layout: 'app',
            hasBottomBar: true,
          },
        },
        {
          path: 'stack/:id',
          name: 'Stack',
          component: () => import(/* webpackChunkName: "app-stack" */ './views/Content-View.vue'),
          meta: {
            requiresAuth: true,
            isContentView: true,
            layout: 'app',
            hasTopBar: true,
          },
        },
        {
          path: 'edit-stack/:id',
          name: 'StackEditor',
          component: () =>
            import(/* webpackChunkName: "app-editstack" */ './views/StackEditor-View.vue'),
          meta: {
            requiresAuth: true,
            isContentView: true,
            layout: 'app',
            hasTopBar: true,
          },
        },
        {
          path: 'menu',
          name: 'Menu',
          component: () => import(/* webpackChunkName: "app-menu" */ './views/Menu-View.vue'),
          meta: {
            requiresAuth: true,
            layout: 'app',
            hasBottomBar: true,
          },
        },
        {
          path: 'premium',
          name: 'Premium',
          component: () => import(/* webpackChunkName: "app-premium" */ './views/Premium-View.vue'),
          meta: {
            requiresAuth: true,
            layout: 'app',
            hasTopBar: true,
          },
        },
        {
          path: 'premium2',
          name: 'Premium2',
          component: () =>
            import(/* webpackChunkName: "app-premium2" */ './views/Premium2-View.vue'),
          meta: {
            requiresAuth: true,
            layout: 'app',
            hasTopBar: true,
          },
        },
        {
          path: 'subscription',
          name: 'Subscription',
          component: () =>
            import(/* webpackChunkName: "app-subscription" */ './views/Subscription-View.vue'),
          meta: {
            requiresAuth: true,
            layout: 'app',
            hasTopBar: true,
          },
        },
        {
          path: 'help',
          name: 'HelpHome',
          component: () =>
            import(/* webpackChunkName: "app-helphome" */ './views/HelpHome-View.vue'),
          meta: {
            requiresAuth: true,
            layout: 'app',
            hasTopBar: true,
          },
        },
        {
          path: 'help/:id',
          name: 'Help',
          // component: () => import('./views/HelpPage-View.vue'),
          component: () => import(/* webpackChunkName: "app-help" */ './views/Content-View.vue'),
          meta: {
            requiresAuth: true,
            isContentView: true,
            layout: 'app',
            hasTopBar: true,
          },
        },
        {
          path: 'contact',
          name: 'Contact',
          component: () => import(/* webpackChunkName: "app-contact" */ './views/Contact-View.vue'),
          meta: {
            requiresAuth: true,
            layout: 'app',
            hasTopBar: true,
          },
        },
        {
          path: 'account',
          name: 'Account',
          component: () => import(/* webpackChunkName: "app-account" */ './views/Account-View.vue'),
          meta: {
            requiresAuth: true,
            layout: 'app',
            hasTopBar: true,
          },
        },
        {
          path: 'about',
          name: 'About',
          component: () => import(/* webpackChunkName: "app-about" */ './views/About-View.vue'),
          meta: {
            requiresAuth: true,
            layout: 'app',
            hasTopBar: true,
          },
        },
        {
          path: 'welcome',
          name: 'Welcome',
          component: () => import(/* webpackChunkName: "app-welcome" */ './views/Content-View.vue'),
          meta: {
            requiresAuth: true,
            isContentView: true,
            layout: 'app',
          },
        },
        {
          path: 'get-started',
          name: 'GetStarted',
          component: () =>
            import(/* webpackChunkName: "app-getstarted" */ './views/GetStarted-View.vue'),
          meta: {
            requiresAuth: true,
            layout: 'app',
            hasTopBar: true,
          },
        },
      ],
    },
    {
      path: '/admin/:page?',
      name: 'Admin',
      component: () => import(/* webpackChunkName: "admin" */ './views/Admin-View.vue'),
      meta: {
        requiresAuth: true,
        isAdminView: true,
      },
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(route => route.meta.requiresAuth);
  const isAdminView = to.matched.some(route => route.meta.isAdminView);
  const { currentUser } = fb.auth;
  const isIOSApp = navigator && navigator.userAgent.includes('capacitor-ios');

  if (to.name === 'Landing' && isIOSApp) {
    next('/app');
  } else if (requiresAuth && !currentUser) {
    next({ name: 'Auth', query: { redirect: to.path } });
  } else if (isAdminView) {
    const { uid } = currentUser;
    fb.usersCollection
      .doc(uid)
      .get()
      .then(doc => {
        const type = doc.data().type || 'free';
        if (type === 'admin') {
          next();
        } else {
          next('/');
        }
      })
      .catch(error => {
        next('/');
        console.log('Error getting user type', error);
      });
  } else if (requiresAuth && currentUser) {
    next();
  } else {
    next();
  }
});

export default router;
